import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

import * as PortalCacheActions from '../actions/portal-cache.actions';


@Injectable()
export class PortalCacheEffects {


  loadPortalCaches$ = createEffect(() => {
    return this.actions$.pipe( 

      ofType(PortalCacheActions.execAction),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => EMPTY)
    );
  });


  constructor(private actions$: Actions) {}

}
